import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box, Text } from '@nerdwallet/currency';
import styles from './back-to-top.module.scss';
import { stringInputSpec } from '../../lib/editing-configs';
import UniversalContainer from '../universal-container';

let currentWindow = null;
const scrollingPageValue = 75; // how much the page was scrolled

const BackToTop = ({ container, alternateIconUrl }) => {
  const [show, setShow] = useState(false);

  const handleOnScroll = useCallback((e) => {
    if (e.target.scrollingElement.scrollTop > scrollingPageValue) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    currentWindow = window;
    currentWindow.addEventListener('scroll', handleOnScroll);
    return () => {
      if (currentWindow) {
        currentWindow.removeEventListener('scroll', handleOnScroll);
      }
    };
  }, [handleOnScroll]);

  const handleScrollToTop = () => {
    if (currentWindow) {
      currentWindow.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <UniversalContainer {...container}>
      <Box
        onClick={handleScrollToTop}
        style={{
          backgroundImage: `url(${alternateIconUrl || null})`,
        }}
        className={classNames(styles.container, [
          {
            [styles.visible]: show,
            [styles.alternateIcon]: alternateIconUrl,
          },
        ])}
      >
        <Text align="center">Back to Top</Text>
      </Box>
    </UniversalContainer>
  );
};

BackToTop.displayName = 'Back to Top';

BackToTop.propTypes = {
  container: UniversalContainer.propTypes,
  alternateIconUrl: PropTypes.string,
};

BackToTop.defaultProps = {
  alternateIconUrl: '',
};

BackToTop.getEditingConfig = (componentDocument) => {
  return [
    ...UniversalContainer.getEditingConfig(
      componentDocument,
      'Container',
      ['hide'],
      'container',
      {
        disableGroup: true,
      }
    ),
    stringInputSpec('alternateIconUrl', 'Alternate back to top icon URL'),
  ];
};

export default BackToTop;
